import { COLORS } from '@shared/config/colors/colors';
import { baseShadowStyle } from '@shared/style/base-shadow';
import { styled } from 'goober';

export const NetworkWrapper = styled('div')`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${COLORS.neutral_00};
    border-radius: 20px;
    ${baseShadowStyle}
`;

export const BodyItem = styled('li')`
    display: flex;
    padding-top: 16px;
    flex-direction: column;
    gap: 8px;

    &:not(:last-child) {
        padding-bottom: 17px;
        &::after {
            display: block;
            content: '';
            width: 100%;
            height: 1px;
            transform: translateY(17px);
            background-color: ${COLORS.neutral_20};
        }
    }
`;

export const ContactList = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const ContactListItem = styled('a')`
    display: flex;
    align-items: center;
    gap: 4px;
`;
